<template>
  <div class="axios-loading">
    <VueSpinner color="white" :size="size" />
  </div>
</template>
<script>
import { VueSpinner } from "vue3-spinners";
export default {
  name: "AxiosLoading",
  components: { VueSpinner },
  props: {
    size: Number,
  },
};
</script>
